import { GLAccount, GLLedgerEntry, JournalEntry } from '../types/business';

// ============================================
// Mock Data
// ============================================

const MOCK_GL_ACCOUNTS: GLAccount[] = [
  // Assets
  { id: 1010, name: 'Cash - Checking', code: '1010', type: 'asset', balanceCents: 8472350, active: true, linkedBankAccountId: 1, parentId: null },
  { id: 1020, name: 'Cash - Savings', code: '1020', type: 'asset', balanceCents: 25000000, active: true, linkedBankAccountId: 2, parentId: null },
  { id: 1030, name: 'Cash - Payroll', code: '1030', type: 'asset', balanceCents: 3125000, active: true, linkedBankAccountId: 4, parentId: null },
  { id: 1100, name: 'Accounts Receivable', code: '1100', type: 'asset', balanceCents: 4250000, active: true, linkedBankAccountId: null, parentId: null },
  { id: 1200, name: 'Inventory', code: '1200', type: 'asset', balanceCents: 1875000, active: true, linkedBankAccountId: null, parentId: null },
  { id: 1300, name: 'Prepaid Expenses', code: '1300', type: 'asset', balanceCents: 450000, active: true, linkedBankAccountId: null, parentId: null },
  { id: 1500, name: 'Property & Equipment', code: '1500', type: 'asset', balanceCents: 7500000, active: true, linkedBankAccountId: null, parentId: null },
  { id: 1600, name: 'Accumulated Depreciation', code: '1600', type: 'asset', balanceCents: -1250000, active: true, linkedBankAccountId: null, parentId: null },
  // Liabilities
  { id: 2000, name: 'Accounts Payable', code: '2000', type: 'liability', balanceCents: 1820000, active: true, linkedBankAccountId: null, parentId: null },
  { id: 2100, name: 'Accrued Liabilities', code: '2100', type: 'liability', balanceCents: 395000, active: true, linkedBankAccountId: null, parentId: null },
  { id: 2200, name: 'Deferred Revenue', code: '2200', type: 'liability', balanceCents: 625000, active: true, linkedBankAccountId: null, parentId: null },
  { id: 2300, name: 'Credit Card Payable', code: '2300', type: 'liability', balanceCents: 345820, active: true, linkedBankAccountId: null, parentId: null },
  { id: 2500, name: 'Long-Term Debt', code: '2500', type: 'liability', balanceCents: 5000000, active: true, linkedBankAccountId: null, parentId: null },
  // Equity
  { id: 3000, name: "Owner's Equity", code: '3000', type: 'equity', balanceCents: 15000000, active: true, linkedBankAccountId: null, parentId: null },
  { id: 3100, name: 'Retained Earnings', code: '3100', type: 'equity', balanceCents: 8250000, active: true, linkedBankAccountId: null, parentId: null },
  // Income
  { id: 4100, name: 'SaaS Revenue', code: '4100', type: 'income', balanceCents: 18500000, active: true, linkedBankAccountId: null, parentId: null },
  { id: 4200, name: 'Professional Services', code: '4200', type: 'income', balanceCents: 4200000, active: true, linkedBankAccountId: null, parentId: null },
  { id: 4300, name: 'Product Sales', code: '4300', type: 'income', balanceCents: 2800000, active: true, linkedBankAccountId: null, parentId: null },
  // COGS
  { id: 5000, name: 'Cost of Goods Sold', code: '5000', type: 'expense', balanceCents: 3500000, active: true, linkedBankAccountId: null, parentId: null },
  { id: 5100, name: 'Hosting & Infrastructure COGS', code: '5100', type: 'expense', balanceCents: 890000, active: true, linkedBankAccountId: null, parentId: null },
  // Expenses
  { id: 6100, name: 'Salaries & Wages', code: '6100', type: 'expense', balanceCents: 8500000, active: true, linkedBankAccountId: null, parentId: null },
  { id: 6150, name: 'Payroll Taxes', code: '6150', type: 'expense', balanceCents: 680000, active: true, linkedBankAccountId: null, parentId: null },
  { id: 6200, name: 'Rent & Occupancy', code: '6200', type: 'expense', balanceCents: 1050000, active: true, linkedBankAccountId: null, parentId: null },
  { id: 6300, name: 'Insurance', code: '6300', type: 'expense', balanceCents: 375000, active: true, linkedBankAccountId: null, parentId: null },
  { id: 6400, name: 'Cloud Infrastructure', code: '6400', type: 'expense', balanceCents: 268500, active: true, linkedBankAccountId: null, parentId: null },
  { id: 6500, name: 'Software & Subscriptions', code: '6500', type: 'expense', balanceCents: 145000, active: true, linkedBankAccountId: null, parentId: null },
  { id: 6600, name: 'Utilities', code: '6600', type: 'expense', balanceCents: 55500, active: true, linkedBankAccountId: null, parentId: null },
  { id: 6700, name: 'Travel & Entertainment', code: '6700', type: 'expense', balanceCents: 245000, active: true, linkedBankAccountId: null, parentId: null },
  { id: 6800, name: 'Marketing & Advertising', code: '6800', type: 'expense', balanceCents: 620000, active: true, linkedBankAccountId: null, parentId: null },
  { id: 6900, name: 'Legal & Professional Fees', code: '6900', type: 'expense', balanceCents: 185000, active: true, linkedBankAccountId: null, parentId: null },
  { id: 7000, name: 'Depreciation Expense', code: '7000', type: 'expense', balanceCents: 125000, active: true, linkedBankAccountId: null, parentId: null },
  { id: 7100, name: 'Office Supplies', code: '7100', type: 'expense', balanceCents: 42500, active: true, linkedBankAccountId: null, parentId: null },
];

const MOCK_JOURNAL_ENTRIES: JournalEntry[] = [
  {
    id: 901,
    entryNumber: 'JE-2026-0142',
    postedAt: '2026-04-10T14:22:00Z',
    memo: 'Record Stripe transfer — April 7 revenue batch',
    sourceType: 'bank_transaction',
    sourceId: 108,
    sourceDisplay: 'STRIPE TRANSFER 04/07',
    lines: [
      { id: 1, glAccountId: 1010, glAccountName: 'Cash - Checking', debitCents: 875000, creditCents: 0, memo: null },
      { id: 2, glAccountId: 4100, glAccountName: 'SaaS Revenue', debitCents: 0, creditCents: 875000, memo: null },
    ],
    isReversal: false,
    reversedByEntryId: null,
  },
  {
    id: 902,
    entryNumber: 'JE-2026-0141',
    postedAt: '2026-04-09T10:05:00Z',
    memo: 'AWS March invoice',
    sourceType: 'bank_transaction',
    sourceId: 103,
    sourceDisplay: 'AWS AMAZON WEB SERVICES 04/09',
    lines: [
      { id: 3, glAccountId: 6400, glAccountName: 'Cloud Infrastructure', debitCents: 89500, creditCents: 0, memo: null },
      { id: 4, glAccountId: 1010, glAccountName: 'Cash - Checking', debitCents: 0, creditCents: 89500, memo: null },
    ],
    isReversal: false,
    reversedByEntryId: null,
  },
  {
    id: 903,
    entryNumber: 'JE-2026-0140',
    postedAt: '2026-04-07T09:30:00Z',
    memo: 'Zoom subscription renewal',
    sourceType: 'bank_transaction',
    sourceId: 107,
    sourceDisplay: 'ZOOM VIDEO COMMUNICATIONS 04/07',
    lines: [
      { id: 5, glAccountId: 6500, glAccountName: 'Software & Subscriptions', debitCents: 14999, creditCents: 0, memo: null },
      { id: 6, glAccountId: 1010, glAccountName: 'Cash - Checking', debitCents: 0, creditCents: 14999, memo: null },
    ],
    isReversal: false,
    reversedByEntryId: null,
  },
  {
    id: 904,
    entryNumber: 'JE-2026-0139',
    postedAt: '2026-04-05T08:00:00Z',
    memo: 'April office rent',
    sourceType: 'bank_transaction',
    sourceId: 109,
    sourceDisplay: 'RENT PAYMENT 04/05',
    lines: [
      { id: 7, glAccountId: 6200, glAccountName: 'Rent & Occupancy', debitCents: 350000, creditCents: 0, memo: null },
      { id: 8, glAccountId: 1010, glAccountName: 'Cash - Checking', debitCents: 0, creditCents: 350000, memo: null },
    ],
    isReversal: false,
    reversedByEntryId: null,
  },
  {
    id: 905,
    entryNumber: 'JE-2026-0138',
    postedAt: '2026-04-01T12:00:00Z',
    memo: 'Q2 liability insurance premium',
    sourceType: 'bank_transaction',
    sourceId: 113,
    sourceDisplay: 'INSURANCE PREMIUM 04/01',
    lines: [
      { id: 9, glAccountId: 6300, glAccountName: 'Insurance', debitCents: 125000, creditCents: 0, memo: null },
      { id: 10, glAccountId: 1010, glAccountName: 'Cash - Checking', debitCents: 0, creditCents: 125000, memo: null },
    ],
    isReversal: false,
    reversedByEntryId: null,
  },
  {
    id: 906,
    entryNumber: 'JE-2026-0137',
    postedAt: '2026-03-31T23:59:00Z',
    memo: 'QuickBooks monthly subscription',
    sourceType: 'bank_transaction',
    sourceId: 114,
    sourceDisplay: 'INTUIT QUICKBOOKS 03/31',
    lines: [
      { id: 11, glAccountId: 6500, glAccountName: 'Software & Subscriptions', debitCents: 7999, creditCents: 0, memo: null },
      { id: 12, glAccountId: 1010, glAccountName: 'Cash - Checking', debitCents: 0, creditCents: 7999, memo: null },
    ],
    isReversal: false,
    reversedByEntryId: null,
  },
  {
    id: 907,
    entryNumber: 'JE-2026-0136',
    postedAt: '2026-03-31T22:00:00Z',
    memo: 'Reverse March accrual - consulting fees',
    sourceType: 'manual',
    sourceId: null,
    sourceDisplay: null,
    lines: [
      { id: 13, glAccountId: 2100, glAccountName: 'Accrued Liabilities', debitCents: 100000, creditCents: 0, memo: 'Reverse accrual' },
      { id: 14, glAccountId: 6900, glAccountName: 'Legal & Professional Fees', debitCents: 0, creditCents: 100000, memo: 'Reverse accrual' },
    ],
    isReversal: true,
    reversedByEntryId: null,
  },
];

const MOCK_LEDGER_ENTRIES: Record<number, GLLedgerEntry[]> = {
  1010: [
    { id: 1, date: '2026-04-10', sourceType: 'bank_transaction', sourceDisplay: 'STRIPE TRANSFER', journalEntryId: 901, debitCents: 875000, creditCents: 0, runningBalanceCents: 8472350, memo: null },
    { id: 2, date: '2026-04-09', sourceType: 'bank_transaction', sourceDisplay: 'AWS AMAZON WEB SERVICES', journalEntryId: 902, debitCents: 0, creditCents: 89500, runningBalanceCents: 7597350, memo: 'March AWS invoice' },
    { id: 3, date: '2026-04-07', sourceType: 'bank_transaction', sourceDisplay: 'ZOOM VIDEO COMMUNICATIONS', journalEntryId: 903, debitCents: 0, creditCents: 14999, runningBalanceCents: 7686850, memo: null },
    { id: 4, date: '2026-04-05', sourceType: 'bank_transaction', sourceDisplay: 'RENT PAYMENT', journalEntryId: 904, debitCents: 0, creditCents: 350000, runningBalanceCents: 7701849, memo: 'April rent' },
    { id: 5, date: '2026-04-01', sourceType: 'bank_transaction', sourceDisplay: 'INSURANCE PREMIUM', journalEntryId: 905, debitCents: 0, creditCents: 125000, runningBalanceCents: 8051849, memo: 'Q2 insurance' },
    { id: 6, date: '2026-03-31', sourceType: 'bank_transaction', sourceDisplay: 'INTUIT QUICKBOOKS', journalEntryId: 906, debitCents: 0, creditCents: 7999, runningBalanceCents: 8176849, memo: null },
  ],
  4100: [
    { id: 7, date: '2026-04-10', sourceType: 'bank_transaction', sourceDisplay: 'STRIPE TRANSFER', journalEntryId: 901, debitCents: 0, creditCents: 875000, runningBalanceCents: 18500000, memo: null },
    { id: 8, date: '2026-03-27', sourceType: 'bank_transaction', sourceDisplay: 'STRIPE TRANSFER', journalEntryId: 910, debitCents: 0, creditCents: 2100000, runningBalanceCents: 17625000, memo: null },
  ],
};

// ============================================
// Service Class
// ============================================

class GLService {
  private accounts: GLAccount[] = [...MOCK_GL_ACCOUNTS];
  private journalEntries: JournalEntry[] = [...MOCK_JOURNAL_ENTRIES];

  async getChartOfAccounts(): Promise<GLAccount[]> {
    return new Promise(resolve => setTimeout(() => resolve([...this.accounts]), 400));
  }

  async getGLAccountLedger(
    glAccountId: number
  ): Promise<{ account: GLAccount; entries: GLLedgerEntry[] }> {
    return new Promise((resolve, reject) =>
      setTimeout(() => {
        const account = this.accounts.find(a => a.id === glAccountId);
        if (!account) return reject(new Error(`GL Account ${glAccountId} not found`));
        const entries = MOCK_LEDGER_ENTRIES[glAccountId] ?? [];
        resolve({ account: { ...account }, entries: [...entries] });
      }, 400)
    );
  }

  async getJournalEntries(): Promise<JournalEntry[]> {
    return new Promise(resolve =>
      setTimeout(() => resolve([...this.journalEntries]), 400)
    );
  }

  async getJournalEntry(id: number): Promise<JournalEntry> {
    return new Promise((resolve, reject) =>
      setTimeout(() => {
        const entry = this.journalEntries.find(e => e.id === id);
        if (!entry) return reject(new Error(`Journal entry ${id} not found`));
        resolve({ ...entry, lines: [...entry.lines] });
      }, 300)
    );
  }
}

export const glService = new GLService();
